module.exports = ".btn_banner {\n  cursor: pointer; }\n"